import { useStore } from '@src/models';

// this is a mess rn
export const useUserData = () => {
  const {
    userStore: { isFetching, user }
  } = useStore();

  // i'm not sure it's secure in prod so let's do this only in dev for now
  const enabled = process.env.NODE_ENV !== 'production' && process.env.UNSTABLE;
  if (enabled) {
    try {
      // get and parse user from local storage
      const userFromLsRaw = localStorage.getItem('user');
      const userFromLs = typeof userFromLsRaw === 'string' && JSON.parse(userFromLsRaw);

      if (isFetching && userFromLs) {
        return [userFromLs, isFetching];
      }

      // after fetching if user obj not null then set it to localstorage
      if (user) localStorage.setItem('user', JSON.stringify(user));
    } catch (error) {
      console.log(error);
    }
  }

  // return fetched user instead of that from localstorage
  return [user, isFetching];
};
